// extracted by mini-css-extract-plugin
export var closeButton = "_fg-2";
export var closeButtonIcon = "_fg-3";
export var lightboxContent = "_fg-1";
export var lightboxOverlay = "_fg-0";